let jQuery = require('jquery');

jQuery(document).on('click', '.flash .close-button', (event) => {
  let flashContainer = jQuery(event.target).parents('.flash');

  flashContainer.remove()
});
